module.exports = __webpack_public_path__ + "media/application/images/icons/external-arrow-58e385be1e65115d88bcf510bda5aa1e.svg";